var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "allocated-orders" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("vue-good-table", {
        attrs: {
          columns: _vm.columns,
          rows: _vm.rows,
          "sort-options": {
            enabled: false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "info"
                  ? _c(
                      "span",
                      { staticClass: "info-con" },
                      _vm._l(props.row.info, function(item, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass: "info-item sk-info-item",
                            class: _vm.borderClass(index, props.row.info.length)
                          },
                          [
                            _c("span", { staticClass: "sk-info-item-title" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sk-info-item-qty" }, [
                              _vm._v(_vm._s(item.qty))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : props.column.field === "po"
                  ? _c("span", [
                      props.row.po.po_required && props.row.po.po_number
                        ? _c("span", [_vm._v(_vm._s(props.row.po.po_number))])
                        : props.row.po.po_required && !props.row.po.po_number
                        ? _c("span", [_vm._v("...")])
                        : _c("span", [_vm._v("not required")])
                    ])
                  : props.column.field === "update"
                  ? _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "order-btn orange",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return (function() {
                                return _vm.onUpdateItem(props.row.id)
                              })($event)
                            }
                          }
                        },
                        [_vm._v("Update")]
                      )
                    ])
                  : props.column.field === "delete"
                  ? _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "order-btn red",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return (function() {
                                return _vm.onDeleteItem(props.row.id)
                              })($event)
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n    " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n  "
                      )
                    ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-header mt-15" }, [
      _c("h3", [_vm._v("COMPLETED ORDER ALLOCATIONS:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }